import * as Roles from '@/store/roles';

export const inspectionTemplateActionsPermissions = {
  syncInspectionTemplate: [Roles.Any],
  getInspectionTemplate: [Roles.Any],
  getInspectionTemplates: [Roles.Any],
  deleteInspectionTemplate: [Roles.Any],
  addInspectionTemplateFromItems: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  addInspectionTemplate: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  loadProjectInspectionTemplates: [Roles.Any],
  saveInspectionTemplateProperties: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  saveInspectionSectionItemProperties: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  saveInspectionSectionProperties: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionTemplateActionsPermissions.js